import {useReversalService} from '../../service/reversal/index'

const useUpdateReversal = () => {
    const {updateReversal} = useReversalService()
  const updateReversalForm = async (data: any) => {
   const resp =  await updateReversal(data)
   if(resp.status === 200) {
    return resp;

   }
   else {
  }
  };
  return {
    updateReversalForm,
  };
};

export default useUpdateReversal;
